import { renderSlot as _renderSlot, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "justify-center items-center flex overflow-hidden fixed inset-0 z-60 outline-none focus:outline-none" }
const _hoisted_2 = {
  class: "relative",
  style: {"max-width":"800px","min-width":"400px"}
}
const _hoisted_3 = { class: "rounded-xl xxl:rounded-2xl shadow-lg p-6 relative flex flex-col bg-white outline-none focus:outline-none" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "opacity-50 fixed inset-0 z-30 bg-black" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ]),
    _hoisted_4
  ], 64))
}